{
  "schemaVersion": "cogo.document-template-family.v2",
  "familyId": "standard-report",
  "familyVersion": "1.0.0",
  "name": "표준 보고서",
  "description": "표지·목차·요약·본문·부록 5부 구성 표준 보고서 템플릿 패밀리. 문서 DS(@ds:document.*)를 designTokenRefs로 참조한다.",
  "metadata": {
    "ownerRef": "platform://cogo",
    "locale": "ko-KR",
    "tags": [
      "standard-report",
      "document-ontology",
      "document-design-system"
    ]
  },
  "legacyTemplateRefs": [],
  "semanticCore": {
    "dataSchema": {
      "ref": "input.schema.json",
      "sha256": "sha256:b8725b4daccfe541c3af6ad3267ae75547ab5ef4d29371737c8c02ec4312d8c8"
    },
    "slots": [
      {
        "id": "cover",
        "kind": "rich-text",
        "bindingPath": "/cover",
        "required": true,
        "semanticRole": "cover"
      },
      {
        "id": "toc",
        "kind": "table",
        "bindingPath": "/toc",
        "required": true,
        "semanticRole": "toc"
      },
      {
        "id": "summary",
        "kind": "rich-text",
        "bindingPath": "/summary",
        "required": true,
        "semanticRole": "summary"
      },
      {
        "id": "body",
        "kind": "rich-text",
        "bindingPath": "/body",
        "required": true,
        "semanticRole": "body"
      },
      {
        "id": "appendix",
        "kind": "rich-text",
        "bindingPath": "/appendix",
        "required": true,
        "semanticRole": "appendix"
      }
    ],
    "tokens": {
      "designTokenRefs": [
        "@ds:document.standard-report-a.v1"
      ]
    },
    "assets": [],
    "guidelineRefs": [
      {
        "ref": "guideline://cogo/document-template-quality/v2",
        "required": true
      }
    ],
    "llmPolicy": {
      "allowedRoles": [
        "semantic-input-assistant",
        "layout-proposal-assistant",
        "content-revision-assistant"
      ],
      "canonicalAuthority": false,
      "finalWriterAllowed": false,
      "outputRequiresValidation": true
    },
    "actionFlowRefs": [
      {
        "id": "generate-document",
        "ref": "actionflow://document-template/generate/v1",
        "role": "generation"
      },
      {
        "id": "approve-document",
        "ref": "actionflow://document-template/approve/v1",
        "role": "approval"
      },
      {
        "id": "publish-document",
        "ref": "actionflow://document-template/publish/v1",
        "role": "publication"
      }
    ],
    "proofProfile": {
      "requiredForPromotion": true,
      "nativeStructureReadbackRequired": true,
      "targetReadbackRequired": true,
      "structureHashRequired": true,
      "providerVersionPolicy": "required-when-provider",
      "visualDiffPolicy": "when-layout-bearing",
      "evidenceRetention": "immutable"
    },
    "sourceProvenance": {
      "required": true,
      "sourceRefs": [
        "input.schema.json",
        "flow-page.v1.json"
      ],
      "preserveProviderVersion": true,
      "sourceAdaptersCanonical": false
    }
  },
  "promotionPolicy": {
    "humanPromotionRequired": true,
    "automatedPromotionAllowed": false,
    "modelMayApprove": false,
    "evidenceRequired": true
  },
  "variants": [
    {
      "variantId": "flow-page-standard-report",
      "name": "Flow Page Standard Report",
      "layoutProfile": "flow-page",
      "capabilityStatus": "partial",
      "knownLimitations": [
        "WordGard edits narrative nodes only; complex tables, charts, and package layout remain adapter-owned.",
        "Google Docs requires a configured native source document before publication."
      ],
      "layout": {
        "kind": "flow-page",
        "layoutRef": "flow-page.v1.json",
        "layoutSha256": "sha256:270a80e6949e70b1fd6999c44b49b6d247220de11ad5a0d024623233b0d18bf8",
        "pagination": "flow"
      },
      "sourcePolicy": {
        "canonicalModel": "cogo-document-template-family",
        "editorAdapters": [
          "wordgard",
          "google-docs"
        ],
        "adapterCanonicalAuthority": false
      },
      "slotBindings": [
        {
          "slotId": "cover",
          "bindingRef": "flow-page.v1.json#/slotBindings/0"
        },
        {
          "slotId": "toc",
          "bindingRef": "flow-page.v1.json#/slotBindings/1"
        },
        {
          "slotId": "summary",
          "bindingRef": "flow-page.v1.json#/slotBindings/2"
        },
        {
          "slotId": "body",
          "bindingRef": "flow-page.v1.json#/slotBindings/3"
        },
        {
          "slotId": "appendix",
          "bindingRef": "flow-page.v1.json#/slotBindings/4"
        }
      ],
      "approvedOmissions": [],
      "renderTargets": [
        "docx",
        "hwpx"
      ],
      "publicationTargets": [],
      "targetOverlays": [
        {
          "target": "docx",
          "adapter": "cogo-document-renderer:docx",
          "canonicalAuthority": false,
          "implementationStatus": "partial",
          "readbackRequired": true,
          "templateMode": "generated-from-cogo"
        },
        {
          "target": "hwpx",
          "adapter": "cogo-document-renderer:hwpx",
          "canonicalAuthority": false,
          "implementationStatus": "partial",
          "readbackRequired": true,
          "templateMode": "generated-from-cogo"
        }
      ]
    }
  ]
}
